import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  Typography
} from '@mui/material';
import { toast } from 'react-toastify';
import { ArrowBack } from '@mui/icons-material';

function EditHolidayPage() {
  const { id } = useParams(); // holiday ID from the URL
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [holidayDate, setHolidayDate] = useState('');
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    // Fetch existing holiday data
    const fetchHoliday = async () => {
      try {
        const res = await api.get(`/holidays/${id}`);
        const data = res.data;
        setName(data.name);
        setHolidayDate(data.holiday_date);
        setIsActive(data.is_active);
      } catch (error) {
        console.error(error);
        toast.error('Failed to load holiday details.');
      }
    };

    fetchHoliday();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/admin/holidays/${id}`, {
        name,
        holiday_date: holidayDate,
        is_active: isActive,
      });
      toast.success('Holiday updated successfully!');
      navigate('/admin/holidays');
    } catch (error) {
      console.error(error);
      toast.error('Failed to update holiday. Please try again.');
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: 'auto', mt: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2
        }}
      >
        <Typography variant="h5" gutterBottom>
          Edit Holiday
        </Typography>
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Holiday Name"
          variant="outlined"
          fullWidth
          required
          sx={{ mb: 2 }}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <TextField
          label="Holiday Date"
          type="date"
          variant="outlined"
          fullWidth
          required
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
          value={holidayDate}
          onChange={(e) => setHolidayDate(e.target.value)}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              color="primary"
            />
          }
          label="Active"
        />

        <Button
          variant="contained"
          color="primary"
          type="submit"
          sx={{ mt: 2 }}
        >
          Update Holiday
        </Button>
      </form>
    </Box>
  );
}

export default EditHolidayPage;
